import { create } from "zustand";

interface TestingState {
  canTest: boolean;
  enable: () => void;
  disable: () => void;
  set: (bool: boolean) => void;
}

export const useTesting = create<TestingState>((set) => ({
  canTest: true,
  enable: () => {
    set(() => ({
      canTest: true,
    }));
  },
  disable: () => {
    set(() => ({
      canTest: false,
    }));
  },
  set: (bool: boolean) => {
    set(() => ({ canTest: bool }));
  },
}));
